var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-transfer',{attrs:{"filterable":"","data":_vm.stockTakings,"titles":['Összes leltár', 'Kiválasztott leltárak'],"props":{
    key: 'id',
    label: 'receipt_number'
  }},on:{"change":_vm.onSelectedStockTakingsChange},model:{value:(_vm.selectedStockTakings),callback:function ($$v) {_vm.selectedStockTakings=$$v},expression:"selectedStockTakings"}})}
var staticRenderFns = []

export { render, staticRenderFns }